import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { pendingTasksReducer } from 'react-redux-spinner'
import app from './app'
import formError from './formError'
import paymentSimulator from 'modules/Simulator/MainApp/reducers'
import bankSimulator from 'modules/Simulator/MainApp/InternetBankingSimulatorApp/reducers'
import settings from 'modules/Simulator/MainApp/Settings/reducers'

export default combineReducers({
  routing: routerReducer,
  pendingTasks: pendingTasksReducer,
  app,
  formError,
  paymentSimulator,
  bankSimulator,
  settings
})



// WEBPACK FOOTER //
// ./src/reducers/index.js